import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { Fragment } from 'react';
import { BaseCell, BaseHeader } from './Column';
import { Responsive } from '../../../../../../ui';

interface IBaggageBeltProps {
	baggageBelt: string[];
}

const styles = css`
	max-width: 130px;

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		display: none;
	}
`;

export const StyledHeader = styled(BaseHeader)`
	${styles}
`;

export const StyledCell = styled(BaseCell)`
	${styles};
	font-weight: 500;
`;

export function Header() {
	return <StyledHeader>Baggage claim</StyledHeader>;
}

export function Cell({ baggageBelt }: IBaggageBeltProps) {
	return (
		<StyledCell>
			{baggageBelt?.map((belt: string) => (
				<Fragment key={belt}>{belt ?? 'Not available'}</Fragment>
			))}
		</StyledCell>
	);
}
